import React, { useState, useRef, useEffect, useMemo } from 'react';
import "./dropdown.css";
import { FiChevronDown, FiSearch } from "react-icons/fi";

const Dropdown = ({ label, options, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const wrapper = useRef(null);
  const input = useRef(null);

  const shown = useMemo(() => {
    if (search === "") return options;

    return options.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }, [options, search]);

  useEffect(() => {
    if (open && input.current) input.current.focus();
  }, [open]);

  useEffect(() => {
    const clickOutside = (event) => {
      if (wrapper.current && !wrapper.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", clickOutside);

    return () => {document.removeEventListener("mousedown", clickOutside)}
  }, [])

  const select = (option) => {
    onChange(option);
    setSearch("");
    setOpen(false);
  }

  return (
    <div className='dropdown' ref={wrapper}>
      <button
        type='button'
        className='dropdown-button fcb'
        aria-haspopup='listbox'
        aria-expanded={open}
        onClick={() => setOpen(prev => !prev)}
      >
        <span className={value === "" ? "selected placeholder" : "selected"}>
          {value === "" ? label : value}
        </span>
        <FiChevronDown className={open ? "caret open" : "caret"} />
      </button>
      {
        open &&
        <div className="dropdown-panel">
          <div className="dropdown-search fcs">
            <FiSearch />
            <input
              ref={input}
              type='text'
              placeholder='Search...'
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={e => {
                if (e.key === "Escape") setOpen(false);
                if (e.key === "Enter" && shown.length > 0) select(shown[0]);
              }}
            />
          </div>
          <ul className="dropdown-list" role='listbox'>
            <li
              className={value === "" ? "dropdown-option selected" : "dropdown-option"}
              role='option'
              aria-selected={value === ""}
              onClick={() => select("")}
            >
              {label}
            </li>
            {
              shown.map((option, i) => (
                <li
                  key={i}
                  className={option === value ? "dropdown-option selected" : "dropdown-option"}
                  role='option'
                  aria-selected={option === value}
                  onClick={() => select(option)}
                >
                  {option}
                </li>
              ))
            }
            {shown.length === 0 && <li className="dropdown-empty">no match</li>}
          </ul>
        </div>
      }
    </div>
  )
}

export default Dropdown
